import { useEffect, useState } from 'react';

export const useCheckFeishuClipper = () => {
  const [hasFeishuClipper, setHasFeishuClipper] = useState(false);

  useEffect(() => {
    const checkFeishuClipper = () => {
      const element = document.getElementById('__FEISHU_CLIPPER___app');
      setHasFeishuClipper(!!element);
    };

    checkFeishuClipper();

    const observer = new MutationObserver(() => {
      checkFeishuClipper();
    });

    observer.observe(document.body, {
      childList: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return hasFeishuClipper;
};
